var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8964_33909)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M1920 0H0V1080H1920V0Z",
    fill: "#E8D0C7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8964_33909",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 1080
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1080H1920V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8964_33909)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 829.501C0 829.501 188.5 963.901 544.6 962.701C900.7 961.501 1046.2 804.201 1335.1 720.401C1624.1 636.601 1920 716.901 1920 716.901V1046C1920 1046 1578.6 857.201 1325.6 901.001C1072.6 944.801 916.8 1058 706.5 1167.5C543.3 1252.5 168.4 1292 0 1098.1L0 829.501Z",
    fill: "#F0D0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.3 767.904C1608.3 767.904 1607.5 766.804 1608.5 764.104C1609.5 761.504 1613 756.504 1611.6 747.004C1610.2 737.604 1605.4 730.004 1605.4 730.004",
    stroke: "#B88261",
    strokeWidth: 0.8774,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.1 726.804C1602.4 727.204 1603.7 729.204 1604.6 730.204C1605.6 731.204 1606.5 732.304 1606.9 733.204C1606.9 733.204 1606.1 730.004 1605.3 728.804C1604.6 727.404 1603.8 726.404 1603.1 726.804Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606.2 768.906C1606.2 768.906 1605.9 767.605 1603.2 766.605C1600.6 765.605 1594.5 765.106 1588.2 757.906C1581.9 750.706 1579.3 742.105 1579.3 742.105",
    stroke: "#B88261",
    strokeWidth: 0.8774,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1578.3 738.204C1579.1 738.004 1579.7 740.204 1579.8 741.604C1580 743.004 1580.1 744.404 1580.5 745.304C1580.5 745.304 1578.6 742.704 1578.2 741.204C1577.8 739.804 1577.5 738.504 1578.3 738.204Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.9 782.204C1605.9 782.204 1590.6 791.604 1580 822.104C1569.4 852.604 1577.4 854.404 1580.2 854.604C1583 854.804 1605.3 856.404 1614 854.704C1622.6 853.004 1623 849.004 1623.7 841.704C1624.3 834.304 1625.1 823.104 1626.1 816.504C1627.1 809.904 1621 797.604 1618.2 792.304C1615.4 786.904 1609 779.904 1605.9 782.204Z",
    fill: "#E7B283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605 789.203C1605 789.203 1599.6 793.403 1598.7 795.203L1601.3 796.803C1601.4 796.803 1603.3 791.803 1605 789.203Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.4 807.203C1594.4 807.203 1589.5 813.003 1586.3 819.203C1583 825.403 1585 828.903 1587.3 827.703C1589.5 826.603 1589.8 813.403 1594.4 807.203Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.1 792.203C1610.9 792.703 1610.2 794.703 1608.3 798.103C1606.4 801.503 1605.3 805.103 1606.1 807.103C1607 809.003 1608 809.703 1609.5 814.503C1611 819.303 1610.7 828.003 1609.5 828.303C1608.3 828.603 1609.5 822.703 1607.9 817.303C1606.3 811.903 1606.5 810.203 1605.1 809.003C1603.7 807.803 1603.3 825.603 1602.5 827.703C1601.9 829.803 1600.8 828.903 1600.7 825.403C1600.5 821.903 1602.8 810.403 1602.7 808.803C1602.6 807.203 1600.1 810.803 1597.9 815.203C1595.7 819.603 1593.2 826.903 1592.2 826.303C1591.2 825.703 1594.5 817.503 1598 812.103C1601.4 806.703 1602.2 808.103 1602.8 806.403C1603.4 804.703 1604.2 801.603 1605.8 798.203C1607.7 794.703 1608.9 791.403 1610.1 792.203Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613 803.505C1613.3 802.405 1613.6 806.705 1614.8 808.905C1616 811.105 1617 811.705 1614.6 812.105C1612.4 812.605 1612 807.105 1613 803.505Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.8 815.503C1622 816.003 1620.9 826.303 1620.7 827.703C1620.5 829.103 1618.9 833.703 1617.2 833.303C1615.5 832.903 1618.1 827.403 1618.9 824.003C1619.8 820.703 1619.7 815.003 1620.8 815.503Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.2 834.002C1624.2 834.002 1622.8 841.002 1619.5 841.402C1616.2 841.902 1611.7 838.402 1609.6 834.002C1609.6 834.002 1609.4 839.202 1606.2 839.802C1603 840.402 1599.2 831.902 1599.2 831.902C1599.2 831.902 1598.8 839.702 1595 840.302C1591.3 840.902 1587.7 833.102 1587.7 833.102C1587.7 833.102 1586.2 839.702 1581.9 839.802C1577.6 839.902 1576.4 836.002 1576.4 836.002C1576.4 836.002 1578.3 843.402 1582.6 843.002C1586.9 842.602 1587.7 837.202 1587.7 837.202C1587.7 837.202 1590.8 844.602 1594.9 843.802C1599 843.102 1599.9 837.302 1599.9 837.302C1599.9 837.302 1602.6 844.402 1606.9 843.902C1611.2 843.302 1610.3 838.802 1610.3 838.802C1610.3 838.802 1614.6 845.802 1619.7 844.602C1624.9 843.102 1624.2 834.002 1624.2 834.002Z",
    fill: "#C0DEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.8 847.403C1622.8 847.403 1621.4 849.703 1617 850.003C1612.6 850.303 1612 847.003 1612 847.003C1612 847.003 1607.9 850.803 1605 850.303C1602 849.703 1600.7 846.203 1600.7 846.203C1600.7 846.203 1596.9 850.003 1593.1 849.703C1589.3 849.403 1587.1 846.003 1587.1 846.003C1587.1 846.003 1584.2 848.803 1580.1 848.403C1576.1 848.003 1574.4 845.703 1574.4 845.703C1574.4 845.703 1574.1 847.703 1575 850.703C1576 853.703 1577.2 854.503 1580.4 854.703C1583.6 854.903 1595.4 855.603 1604.5 855.503C1613.9 855.403 1621.4 854.803 1622.8 847.403Z",
    fill: "#C0DEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1618.6 776.405C1618.6 776.405 1635.7 770.905 1665.7 782.605C1695.8 794.405 1691.9 801.605 1690.3 803.805C1688.6 806.005 1675.3 824.005 1668.5 829.605C1661.6 835.105 1658.3 832.805 1652.3 828.505C1646.2 824.205 1637.3 817.505 1631.6 813.905C1625.9 810.505 1620.6 797.705 1618.2 792.105C1615.9 786.605 1614.8 777.205 1618.6 776.405Z",
    fill: "#E7B283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.4 780.203C1624.4 780.203 1631 778.803 1633 779.303L1632.5 782.303C1632.6 782.403 1627.6 780.603 1624.4 780.203Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645 783.906C1645 783.906 1652.6 784.006 1659.4 785.506C1666.2 787.006 1667.6 790.806 1665.2 791.706C1662.9 792.706 1652.6 784.506 1645 783.906Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623.39 786.103C1623.29 787.103 1625.19 787.803 1629.09 788.603C1632.99 789.403 1636.49 790.903 1637.29 792.803C1638.19 794.703 1637.99 795.903 1640.69 800.203C1643.39 804.503 1650.09 809.903 1651.29 809.203C1652.29 808.503 1647.09 805.603 1643.89 800.903C1640.69 796.203 1639.39 795.203 1639.29 793.403C1639.29 791.603 1653.09 802.803 1655.09 803.603C1657.09 804.403 1657.09 803.103 1654.49 800.703C1651.89 798.303 1641.69 792.503 1640.59 791.403C1639.49 790.303 1643.79 790.803 1648.49 791.903C1653.19 793.103 1660.39 795.903 1660.69 794.803C1660.89 793.703 1652.49 790.803 1646.09 789.903C1639.69 789.003 1640.29 790.503 1638.69 789.803C1637.09 789.103 1634.19 787.703 1630.49 786.803C1626.89 785.903 1623.59 784.603 1623.39 786.103Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630.1 795.706C1629.1 795.206 1632.1 798.306 1633.1 800.606C1634.1 802.906 1633.8 804.006 1635.6 802.606C1637.4 801.006 1633.5 797.306 1630.1 795.706Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.19 809.406C1633.79 810.706 1642.39 816.506 1643.49 817.206C1644.59 818.006 1649.29 819.706 1650.09 818.206C1650.89 816.706 1644.99 815.006 1641.89 813.506C1638.79 812.006 1634.59 808.206 1634.19 809.406Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646 823.906C1646 823.906 1652.2 827.306 1654.7 825.106C1657.2 822.906 1657.4 817.206 1655.5 812.806C1655.5 812.806 1659.6 816.106 1662.1 813.906C1664.6 811.806 1660.6 803.506 1660.6 803.506C1660.6 803.506 1666.8 808.206 1669.6 805.806C1672.6 803.406 1668.9 795.606 1668.9 795.606C1668.9 795.606 1674.9 798.706 1677.8 795.606C1680.6 792.406 1678.4 788.906 1678.4 788.906C1678.4 788.906 1682.7 795.106 1679.7 798.206C1676.7 801.206 1671.9 798.306 1671.9 798.306C1671.9 798.306 1675.4 805.406 1672.2 808.106C1669 810.706 1664 807.706 1664 807.706C1664 807.706 1667.7 814.406 1664.4 817.306C1661.1 820.206 1658.3 816.506 1658.3 816.506C1658.3 816.506 1660.9 824.306 1656.5 827.406C1652.5 830.406 1646 823.906 1646 823.906Z",
    fill: "#C0DEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.09 831.603C1657.09 831.603 1659.69 832.103 1662.89 829.003C1665.99 825.903 1663.89 823.303 1663.89 823.303C1663.89 823.303 1669.39 822.703 1670.89 820.003C1672.39 817.403 1670.59 814.103 1670.59 814.103C1670.59 814.103 1675.99 813.603 1678.19 810.603C1680.39 807.603 1679.19 803.603 1679.19 803.603C1679.19 803.603 1683.19 803.203 1685.49 799.803C1687.79 796.403 1687.09 793.703 1687.09 793.703C1687.09 793.703 1688.79 794.703 1690.49 797.503C1692.19 800.203 1691.89 801.603 1689.89 804.203C1687.89 806.803 1680.79 816.303 1674.89 823.003C1668.99 830.003 1663.69 835.303 1657.09 831.603Z",
    fill: "#C0DEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.2 769.402C1604.2 769.402 1587 766.102 1564.4 779.502C1541.8 792.902 1527 816.402 1523.6 831.302C1523.6 831.302 1525.2 839.902 1537.6 835.502C1537.6 835.502 1538.6 844.502 1551.3 837.702C1551.3 837.702 1550.7 846.502 1563.7 839.902C1563.7 839.902 1567.2 844.502 1576.5 835.902C1576.5 835.902 1581.5 802.002 1605.9 782.202C1605.9 782.202 1608.9 779.202 1608.4 774.702C1607.8 770.202 1604.2 769.402 1604.2 769.402Z",
    fill: "#C0DEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1576.5 835.901C1576.5 835.901 1567.8 844.201 1563.7 839.901C1563.7 839.901 1551.6 846.701 1551.3 837.701C1551.3 837.701 1539.1 844.701 1537.6 835.501C1537.6 835.501 1526 840.301 1523.6 831.301L1522.6 836.301C1522.6 836.301 1525.4 844.101 1536 840.201C1536 840.201 1539.8 848.901 1549.6 843.201C1549.6 843.201 1551 849.401 1561.8 844.201C1561.8 844.201 1565.8 850.801 1576.2 840.801L1576.5 835.901Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547 852.601C1547 852.601 1539.3 856.401 1531.2 851.601C1523.1 846.701 1522.3 843.401 1521.9 842.001C1521.5 840.601 1522.5 836.301 1522.5 836.301C1522.5 836.301 1525.3 844.101 1535.9 840.201C1535.9 840.201 1539.8 849.001 1549.5 843.201C1549.5 843.201 1551 849.401 1561.7 844.201C1561.7 844.201 1566.4 850.501 1576.1 840.801C1576.1 840.801 1571.9 850.001 1564 853.801C1556.2 857.801 1548.5 854.901 1547 852.601Z",
    fill: "#F3C6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1536.2 805.604C1536.2 805.604 1542.8 799.704 1548.6 801.604C1554.5 803.504 1552.3 821.004 1552.3 821.004C1552.3 821.004 1563.9 805.304 1571.6 806.304C1579.3 807.304 1580 822.104 1580 822.104C1580 822.104 1576.7 833.104 1576.5 835.904C1576.5 835.904 1567.4 844.304 1563.7 839.904C1563.7 839.904 1551.3 846.904 1551.3 837.704C1551.3 837.704 1539.3 844.904 1537.6 835.504C1537.6 835.504 1525.6 840.104 1523.6 831.304C1523.5 831.404 1526.6 818.304 1536.2 805.604Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.2 773.602C1602.2 773.602 1594.5 774.002 1576.8 782.302C1559.1 790.602 1548.9 800.402 1547.8 801.302C1546.7 802.202 1546.1 803.102 1546.1 803.102C1546.1 803.102 1539.9 804.902 1535.1 811.302C1530.2 817.602 1530 818.702 1530.5 819.002C1531 819.302 1531.5 818.502 1532.1 817.602C1532.7 816.602 1538.3 807.802 1545 804.802C1545 804.802 1542.4 808.002 1539.9 812.302C1537.3 816.702 1534.9 821.602 1535.8 822.102C1536.6 822.702 1537.6 819.902 1538.7 817.202C1539.8 814.602 1545.9 805.302 1545.9 805.302C1545.9 805.302 1544.3 808.202 1542.9 812.902C1541.5 817.602 1539.9 822.102 1541.1 822.702C1542.3 823.302 1543.2 818.902 1543.7 816.302C1544.3 813.702 1546.6 807.202 1547.4 805.302C1547.4 805.302 1549.4 811.102 1549 815.702C1548.6 820.302 1547.2 824.302 1548 824.702C1548.7 825.102 1550 821.302 1550.5 816.702C1551 812.102 1550.2 808.102 1548.3 803.502C1548.3 803.502 1560 792.602 1577.6 783.902C1595.2 775.202 1602.5 775.002 1602.5 775.002L1602.2 773.602Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555.7 825.804C1556.7 826.204 1557.2 824.604 1558.9 822.204C1560.6 819.804 1566.7 814.404 1568.7 813.404C1568.7 813.404 1564.1 821.204 1562.9 823.204C1561.7 825.104 1560.4 828.104 1561.3 828.604C1562.3 829.204 1564.3 824.804 1565.3 822.104C1566.3 819.504 1569.7 814.104 1569.7 814.104C1569.7 814.104 1568.8 818.604 1567.9 821.904C1566.9 825.304 1565.8 830.504 1566.7 830.704C1567.5 830.904 1568.6 826.704 1569.3 822.504C1570 818.304 1570.6 814.404 1570.6 814.404C1570.6 814.404 1572.3 817.204 1572.3 821.004C1572.3 824.804 1571 829.204 1572.1 829.404C1573.1 829.604 1574.6 825.104 1574.5 820.004C1574.4 814.904 1571.5 811.504 1568.5 812.104C1565.4 812.704 1560 817.004 1557.7 820.304C1555.4 823.804 1554.6 825.404 1555.7 825.804Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1589.5 773.203C1589.4 774.003 1589.3 773.803 1586.5 774.603C1583.7 775.403 1575.3 778.103 1569.1 781.503C1562.9 784.803 1558.5 787.703 1557.8 788.503C1557.1 789.203 1556.3 788.403 1557.3 787.503C1558.3 786.503 1567.7 780.303 1576.6 776.903C1585.4 773.403 1589.6 772.703 1589.5 773.203Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.8 803.701C1565.8 803.701 1569.3 799.901 1570.8 797.901C1572.2 795.801 1572.7 792.801 1567.5 794.101C1562.3 795.501 1557.7 799.201 1557.7 799.201C1557.7 799.201 1562.7 800.201 1565.8 803.701Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.9 798.201C1566.9 798.901 1564.1 802.201 1564.1 802.201C1564.1 802.201 1562 800.801 1560.7 800.201C1560.7 800.201 1564.4 797.101 1565.9 798.201Z",
    fill: "#F3C6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1571.6 789.301C1571.6 789.301 1574.8 789.701 1577 793.901C1577 793.901 1586.6 787.901 1585.6 785.001C1584.6 782.001 1571.6 789.301 1571.6 789.301Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.2 788.304C1580.1 789.104 1575.8 792.004 1575.8 792.004L1574.3 790.604C1574.3 790.604 1578.2 787.404 1579.2 788.304Z",
    fill: "#F3C6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1590 780.804L1591.3 783.604C1591.3 783.604 1598 780.604 1597.3 779.104C1596.6 777.804 1590 780.804 1590 780.804Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1600.7 781.703C1601 782.303 1597.9 783.903 1594.1 788.903C1590.3 793.903 1584.9 804.703 1584.2 804.703C1583.5 804.703 1584 802.903 1585.2 799.803C1586.5 796.803 1591.4 790.403 1593.8 787.103C1596.4 783.903 1600.2 781.003 1600.7 781.703Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.6 795.101C1581 795.301 1578.8 797.901 1577.8 800.301C1576.8 802.601 1575.6 803.301 1573.5 802.601C1571.3 802.001 1579.4 794.501 1580.6 795.101Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1550 827.001C1550.2 827.601 1551 827.801 1551.5 827.601C1552 827.401 1552.3 826.601 1552.1 826.101C1551.9 825.501 1551.1 825.301 1550.6 825.501C1550 825.701 1549.8 826.401 1550 827.001Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1548.8 830.602C1549 831.202 1549.8 831.402 1550.3 831.202C1550.9 831.002 1551.1 830.202 1550.9 829.702C1550.7 829.102 1549.9 828.902 1549.4 829.102C1548.8 829.402 1548.6 830.102 1548.8 830.602Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.4 834.899C1547.6 835.499 1548.4 835.699 1548.9 835.499C1549.5 835.299 1549.7 834.499 1549.5 833.999C1549.3 833.399 1548.5 833.199 1548 833.399C1547.4 833.699 1547.1 834.299 1547.4 834.899Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1525.4 844.501C1525.6 845.101 1526.4 845.301 1526.9 845.101C1527.4 844.901 1527.7 844.101 1527.5 843.601C1527.3 843.001 1526.5 842.801 1526 843.001C1525.4 843.301 1525.1 843.901 1525.4 844.501Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1533.5 845.899C1533.7 846.499 1534.5 846.699 1535 846.499C1535.5 846.299 1535.8 845.499 1535.6 844.999C1535.4 844.399 1534.6 844.199 1534.1 844.399C1533.5 844.699 1533.3 845.399 1533.5 845.899Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.7 849.501C1539.9 850.101 1540.7 850.301 1541.2 850.101C1541.8 849.901 1542 849.101 1541.8 848.601C1541.6 848.001 1540.8 847.801 1540.3 848.001C1539.7 848.301 1539.4 849.001 1539.7 849.501Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547 848.602C1547.2 849.202 1548 849.402 1548.5 849.202C1549 849.002 1549.3 848.202 1549.1 847.702C1548.9 847.102 1548.1 846.902 1547.6 847.102C1547.1 847.302 1546.8 848.102 1547 848.602Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553.6 851.102C1553.8 851.702 1554.6 851.902 1555.1 851.702C1555.7 851.502 1555.9 850.702 1555.7 850.202C1555.5 849.602 1554.7 849.402 1554.2 849.602C1553.6 849.902 1553.4 850.602 1553.6 851.102Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.9 849.399C1560.1 849.999 1560.9 850.199 1561.4 849.999C1562 849.799 1562.2 848.999 1562 848.499C1561.8 847.899 1561 847.699 1560.5 847.899C1559.9 848.199 1559.7 848.899 1559.9 849.399Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1566.1 849.7C1566.3 850.3 1567.1 850.5 1567.6 850.3C1568.1 850.1 1568.4 849.3 1568.2 848.8C1568 848.2 1567.2 848 1566.7 848.2C1566 848.5 1565.8 849.1 1566.1 849.7Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1609.9 766.803C1609.9 766.803 1618.6 751.603 1643.4 743.103C1668.3 734.503 1695.7 738.603 1709.3 745.703C1709.3 745.703 1714.8 752.503 1703.3 759.103C1703.3 759.103 1709.5 765.703 1696.1 770.903C1696.1 770.903 1703.1 776.303 1689.7 781.803C1689.7 781.803 1690.9 787.503 1678.3 788.903C1678.3 788.903 1649.3 770.703 1618.4 776.403C1618.4 776.403 1614.1 776.703 1611 773.403C1608.2 770.103 1609.9 766.803 1609.9 766.803Z",
    fill: "#C0DEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1678.5 789.001C1678.5 789.001 1690.5 787.801 1689.9 781.901C1689.9 781.901 1702.9 777.101 1696.3 771.001C1696.3 771.001 1709.4 766.301 1703.5 759.201C1703.5 759.201 1714.7 753.501 1709.5 745.801L1714 748.201C1714 748.201 1718.2 755.401 1708.3 760.901C1708.3 760.901 1712.5 769.501 1701.7 773.201C1701.7 773.201 1705.6 778.201 1694.6 783.101C1694.6 783.101 1697 790.501 1682.6 791.801L1678.5 789.001Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.3 777.403C1710.3 777.403 1718.2 774.003 1719.8 764.803C1721.4 755.603 1719.4 752.703 1718.5 751.503C1717.6 750.203 1713.8 748.203 1713.8 748.203C1713.8 748.203 1718 755.403 1708.1 760.903C1708.1 760.903 1712.3 769.603 1701.5 773.203C1701.5 773.203 1705.2 778.303 1694.4 783.103C1694.4 783.103 1696.2 790.803 1682.4 791.803C1682.4 791.803 1692.2 794.503 1700.2 791.103C1708.2 787.703 1711.1 779.903 1710.3 777.403Z",
    fill: "#F3C6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.5 738.602C1681.5 738.602 1672.8 739.702 1670.4 745.402C1668 751.102 1682.8 760.802 1682.8 760.802C1682.8 760.802 1663.4 759.402 1659.1 765.802C1654.8 772.202 1665.7 782.402 1665.7 782.402C1665.7 782.402 1676.3 787.102 1678.4 788.702C1678.4 788.702 1690.7 787.302 1689.8 781.602C1689.8 781.602 1703.2 776.602 1696.2 770.702C1696.2 770.702 1709.5 766.202 1703.4 758.902C1703.4 758.902 1714.6 752.702 1709.4 745.502C1709.4 745.802 1697.5 739.602 1681.5 738.602Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1614.4 768.004C1614.4 768.004 1619.7 762.404 1637.6 754.304C1655.4 746.204 1669.4 744.904 1670.9 744.504C1672.3 744.304 1673.4 744.404 1673.4 744.404C1673.4 744.404 1678.8 741.004 1686.8 741.304C1694.7 741.704 1695.7 742.204 1695.7 742.704C1695.7 743.204 1694.7 743.204 1693.6 742.904C1692.6 742.704 1682.1 741.204 1675.5 744.404C1675.5 744.404 1679.6 744.504 1684.6 745.404C1689.6 746.304 1694.8 747.604 1694.8 748.704C1694.7 749.704 1692 748.604 1689.2 747.704C1686.4 746.804 1675.4 745.404 1675.4 745.404C1675.4 745.404 1678.6 746.004 1683.2 748.004C1687.8 749.904 1692.2 751.704 1691.8 753.004C1691.4 754.304 1687.6 752.104 1685.2 750.804C1682.8 749.504 1676.4 747.004 1674.4 746.404C1674.4 746.404 1677.5 751.704 1681.3 754.404C1685.1 757.104 1689 758.604 1688.8 759.404C1688.6 760.204 1684.9 758.704 1681.1 756.104C1677.4 753.504 1674.8 750.304 1672.5 745.904C1672.5 745.904 1656.7 747.704 1638.6 755.404C1620.5 763.204 1615.7 768.504 1615.7 768.504L1614.4 768.004Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.2 766.502C1683.8 767.502 1682.3 766.902 1679.4 766.602C1676.5 766.402 1668.4 767.402 1666.3 768.402C1666.3 768.402 1675.3 769.902 1677.5 770.302C1679.7 770.702 1682.8 771.502 1682.6 772.602C1682.4 773.602 1677.8 772.402 1675.1 771.402C1672.5 770.402 1666.1 769.602 1666.1 769.602C1666.1 769.602 1670 771.802 1673.2 773.302C1676.4 774.702 1681 777.302 1680.7 778.102C1680.4 778.902 1676.4 777.002 1672.8 774.802C1669.1 772.602 1665.8 770.602 1665.8 770.602C1665.8 770.602 1666.8 773.702 1669.8 776.202C1672.8 778.702 1676.8 780.502 1676.3 781.502C1675.7 782.502 1671.4 780.502 1667.7 777.202C1663.9 773.802 1663.1 769.402 1665.5 767.402C1667.9 765.402 1674.7 764.102 1678.8 764.502C1683 765.002 1684.6 765.502 1684.2 766.502Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1622.3 758.102C1622.9 758.602 1622.9 758.302 1625.3 756.702C1627.7 755.102 1635.3 750.502 1641.9 747.902C1648.5 745.302 1653.5 743.802 1654.5 743.802C1655.5 743.702 1655.4 742.602 1654 742.802C1652.6 743.002 1641.8 746.102 1633.4 750.602C1625.1 755.002 1621.9 757.802 1622.3 758.102Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1661 759.802C1661 759.802 1655.8 760.002 1653.3 759.802C1650.8 759.502 1648.2 757.902 1652.6 754.802C1657 751.802 1662.9 750.602 1662.9 750.602C1662.9 750.602 1660.3 755.302 1661 759.802Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656.6 756.401C1656.5 757.601 1660.8 757.701 1660.8 757.701C1660.8 757.701 1661 755.101 1661.5 753.801C1661.6 753.801 1656.8 754.601 1656.6 756.401Z",
    fill: "#F3C6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.2 755.004C1646.2 755.004 1644.4 757.704 1646.1 762.104C1646.1 762.104 1635.3 765.504 1633.8 762.804C1632.2 760.104 1646.2 755.004 1646.2 755.004Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640.5 760.003C1640.5 761.203 1645.5 759.803 1645.5 759.803L1645.4 757.703C1645.4 757.803 1640.5 758.703 1640.5 760.003Z",
    fill: "#F3C6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.8 763.402L1629.1 766.202C1629.1 766.202 1622.5 769.302 1621.8 767.902C1621.2 766.402 1627.8 763.402 1627.8 763.402Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.5 772.102C1621.7 772.702 1625 771.402 1631.3 771.802C1637.6 772.202 1649.3 775.102 1649.8 774.502C1650.2 773.902 1648.5 773.202 1645.4 772.202C1642.3 771.202 1634.2 770.702 1630.1 770.502C1626 770.302 1621.2 771.302 1621.5 772.102Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.01 771.626C1621.21 772.226 1624.51 770.926 1630.81 771.326C1637.11 771.726 1648.81 774.626 1649.31 774.026C1649.71 773.426 1648.01 772.726 1644.91 771.726C1641.81 770.726 1633.71 770.226 1629.61 770.026C1625.51 769.826 1620.71 770.826 1621.01 771.626Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1644.71 765.503C1644.61 765.903 1648.01 766.003 1650.51 766.703C1653.01 767.403 1654.11 767.003 1655.11 764.903C1656.11 762.903 1645.01 764.203 1644.71 765.503Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.8 763.003C1689 763.603 1688.8 764.203 1688.2 764.503C1687.6 764.703 1687 764.503 1686.7 763.903C1686.5 763.303 1686.7 762.703 1687.3 762.403C1687.9 762.203 1688.6 762.403 1688.8 763.003Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.4 764.503C1692.6 765.103 1692.4 765.703 1691.8 766.003C1691.2 766.203 1690.6 766.003 1690.3 765.403C1690.1 764.803 1690.3 764.203 1690.9 763.903C1691.5 763.703 1692.2 763.903 1692.4 764.503Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.6 766.202C1696.8 766.802 1696.6 767.402 1696 767.702C1695.4 767.902 1694.8 767.702 1694.5 767.102C1694.3 766.502 1694.5 765.902 1695.1 765.602C1695.7 765.402 1696.3 765.602 1696.6 766.202Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1718.2 755.702C1718.4 756.302 1718.2 756.902 1717.6 757.202C1717 757.502 1716.4 757.202 1716.1 756.602C1715.9 756.002 1716.1 755.402 1716.7 755.102C1717.3 754.902 1717.9 755.102 1718.2 755.702Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1714 762.702C1714.2 763.302 1714 763.902 1713.4 764.202C1712.8 764.402 1712.2 764.202 1711.9 763.602C1711.7 763.002 1711.9 762.402 1712.5 762.102C1713 761.902 1713.8 762.202 1714 762.702Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712.7 769.803C1712.9 770.403 1712.7 771.003 1712.1 771.303C1711.5 771.503 1710.9 771.303 1710.6 770.703C1710.4 770.103 1710.6 769.503 1711.2 769.203C1711.8 769.003 1712.5 769.303 1712.7 769.803Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.3 774.804C1707.5 775.404 1707.3 776.004 1706.7 776.304C1706.1 776.504 1705.5 776.304 1705.2 775.704C1705 775.104 1705.2 774.504 1705.8 774.204C1706.3 774.004 1707 774.204 1707.3 774.804Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.9 781.401C1705.1 782.001 1704.9 782.601 1704.3 782.901C1703.7 783.101 1703.1 782.901 1702.8 782.301C1702.6 781.701 1702.8 781.101 1703.4 780.801C1703.9 780.601 1704.6 780.901 1704.9 781.401Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1699.5 785.104C1699.7 785.704 1699.5 786.304 1698.9 786.604C1698.3 786.804 1697.7 786.604 1697.4 786.004C1697.1 785.404 1697.4 784.804 1698 784.504C1698.6 784.304 1699.2 784.604 1699.5 785.104Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1695.8 789.901C1696 790.501 1695.8 791.101 1695.2 791.401C1694.6 791.601 1694 791.401 1693.7 790.801C1693.5 790.201 1693.7 789.601 1694.3 789.301C1694.8 789.101 1695.4 789.401 1695.8 789.901Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1632.2 820.305C1632.2 820.305 1633 818.705 1632.7 816.505C1632.4 814.305 1628.4 798.705 1625.2 794.605C1622 790.505 1619.3 792.005 1619.3 792.005C1622.3 790.605 1622.4 785.305 1620.5 779.805C1618.5 774.405 1614.3 772.705 1614.3 772.705C1617.6 771.205 1616.8 769.405 1614.5 768.005C1612.3 766.505 1609.1 766.605 1607.9 767.105L1606.1 768.005C1604.9 768.605 1602.8 771.005 1602.4 773.605C1602.1 776.305 1602.9 778.105 1606.2 776.605C1606.2 776.605 1604.8 780.905 1607.6 786.005C1610.4 791.005 1614.6 794.405 1617.6 793.005C1617.6 793.005 1614.7 794.105 1615.8 799.205C1616.8 804.205 1626.1 817.505 1627.6 819.205C1629 820.805 1630.7 821.305 1630.7 821.305C1630.7 821.305 1631.8 821.805 1632.2 820.305Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.4 768.203C1605.4 768.203 1607.9 773.603 1602.2 775.003C1602.2 775.003 1601.8 771.403 1605.4 768.203Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.5 775.504C1610.5 775.504 1608.3 779.304 1607.4 785.904C1607.4 785.904 1612.3 789.604 1617.1 789.704C1620.1 785.904 1620.5 779.904 1620.5 779.904C1614.9 776.304 1610.5 775.504 1610.5 775.504Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1615.5 798.904C1615.5 798.904 1621.1 798.704 1625.1 794.504C1625.1 794.504 1623.5 798.804 1622.1 800.604C1622.1 800.504 1618.7 800.604 1615.5 798.904Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1619 806.603C1619 806.603 1624.6 806.403 1628.6 802.203C1628.6 802.203 1627 806.503 1625.6 808.303C1625.6 808.203 1622.2 808.303 1619 806.603Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1623.6 814.206C1623.6 814.206 1628.3 814.405 1631.4 810.605C1631.4 810.605 1630.4 814.706 1629.2 816.206C1629.3 816.206 1626.5 816.206 1623.6 814.206Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1608.2 767.004C1608.2 767.004 1610.8 772.404 1615.5 768.904C1615.4 768.904 1613.1 766.204 1608.2 767.004Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1620.6 737.702L1630.6 711.402",
    stroke: "#B88261",
    strokeWidth: 0.8774,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.3 733.802L1643.1 722.602",
    stroke: "#B88261",
    strokeWidth: 0.8774,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.1 771.902L1652.7 761.602L1659 768.902L1649.8 767.702L1658.6 761.802L1654.1 771.902Z",
    stroke: "#B88261",
    strokeWidth: 0.9726,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575.8 758.302L1549.4 748.902",
    stroke: "#B88261",
    strokeWidth: 0.8774,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1563.9 766.203L1549.8 765.703",
    stroke: "#B88261",
    strokeWidth: 0.8774,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1951.6 1080.8C1951.6 1080.8 1951.1 1047.5 1937.6 1048.6C1924.2 1049.7 1921.4 1059.7 1921.4 1059.7C1921.4 1059.7 1923 1030 1895.7 1027.2C1868.5 1024.4 1861.7 1044.9 1861.7 1044.9C1861.7 1044.9 1864.1 1022.6 1850.9 1011.1C1837.7 999.499 1826 1007.5 1826 1007.5C1826.8 985.999 1796.1 953.299 1753.4 968.499C1716 981.799 1717.1 1011.3 1718 1018.3C1716.9 1012.2 1711.1 989.799 1685.1 993.299C1655 997.299 1642.7 1031.1 1642.7 1031.1C1634 1004.7 1613.4 997.099 1598.3 996.899C1583.1 996.599 1568 1022.7 1568 1022.7C1565.1 1020.8 1542.4 1006.4 1527.4 1015.2C1524.2 1017.1 1521.8 1019.8 1518.9 1023C1517.3 1024.9 1510.1 1033.2 1505.9 1046.8C1504.4 1051.6 1503.8 1055.3 1503.3 1058.8C1501.9 1067.8 1502 1075.3 1502.3 1080.7",
    fill: "#E3A194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.9 989.902C1579.9 989.902 1579.8 1006.1 1580.5 1023.6C1581.2 1041 1583.1 1050.9 1589.9 1056.9C1596.8 1062.9 1600.6 1063.3 1604.1 1071C1604.1 1071 1607.4 1054.7 1596.4 1033.5C1585.5 1012.2 1579.9 989.902 1579.9 989.902Z",
    fill: "#9AC1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.9 989.902C1579.9 989.902 1583.2 1015.1 1588.9 1033.1C1594.6 1051.1 1602.7 1063.7 1604.2 1070.9",
    stroke: "#B88261",
    strokeWidth: 1.1435,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.1 1012.2L1586.6 1025L1580.2 1012.6",
    stroke: "#B88261",
    strokeWidth: 1.1435,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1593.69 1027.7L1592.19 1042.3L1580.99 1031.3",
    stroke: "#B88261",
    strokeWidth: 1.1435,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.6 1040.2L1598.1 1056L1584.2 1048.4",
    stroke: "#B88261",
    strokeWidth: 1.1435,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.4 908.801V933.601",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640.4 921.199H1626.3",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629 915.699L1637.8 926.499",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.8 915.699L1629 926.499",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.2 957.102V981.902",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.2 969.5H1757.2",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.8 964L1768.6 974.8",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.6 964L1759.8 974.8",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1718.5 941.602V947.002",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.8 944.402H1721.1",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575.4 990.801V996.201",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.8 993.602H1578.1",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1801.3 1044.8C1801.3 1044.8 1792.7 1025.4 1774.5 1026.3C1756.3 1027.3 1752.1 1046.9 1758.4 1044.8C1764.7 1042.7 1757.8 1023.7 1743.6 1017.8C1729.3 1012 1712.4 1021 1713 1036.3C1713.6 1051.7 1725.5 1043.8 1721.5 1033.7C1717.5 1023.5 1703 999.9 1680.2 997.7C1657.5 995.6 1651.6 1025.4 1658.5 1021.3C1665.4 1017.2 1656.3 1010.1 1645.8 1010.3C1628.9 1010.5 1624.1 1046.1 1634.7 1044.9C1645.3 1043.7 1613 1019.9 1599.8 1027.3C1586.6 1034.7 1585.5 1049.1 1590.3 1049C1595.1 1049 1581.8 1031.5 1572.3 1037.9C1562.8 1044.2 1559.9 1080.9 1559.9 1080.9",
    stroke: "#B88261",
    strokeWidth: 1.2509,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671 971.599C1671 971.599 1664.8 991.499 1668.1 1015.9C1671.5 1040.4 1681.9 1058 1681.9 1058L1683.2 1056.1C1683.2 1056.1 1671.4 1042.5 1669.8 1013.7C1668.2 984.799 1673.2 970.699 1673.2 970.699L1671 971.599Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656.8 938.7C1656.8 938.7 1657.8 931.9 1660.5 931.7C1663.1 931.5 1666.7 938.4 1666.7 938.4C1666.7 938.4 1666.6 933.1 1669.3 931.8C1672.1 930.4 1676.6 946.2 1675.1 955.8C1673.7 965.4 1671.7 974.4 1671.7 974.4C1671.7 974.4 1659.1 969.9 1652 954.9C1644.9 939.9 1647.2 934.9 1648.8 934.2C1650.6 933.4 1656.8 938.7 1656.8 938.7Z",
    fill: "#F3C6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.2 930.301C1677.6 930.501 1671.5 946.201 1671.8 974.301C1671.8 974.301 1677.9 970.801 1686.4 962.901C1695 955.101 1698.6 942.801 1699 937.901C1699.3 932.901 1696.2 929.701 1692 934.401C1692 934.401 1691.1 928.001 1688.8 929.001C1686.5 930.001 1684.1 935.801 1684.1 935.801C1684.1 935.801 1684.2 930.001 1681.2 930.301Z",
    fill: "#F6B09E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.8 951.802C1657.8 951.802 1663.1 964.302 1671.9 974.302C1671.9 974.302 1664.3 963.802 1664.3 949.102",
    stroke: "#B88261",
    strokeWidth: 1.5314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691.2 948.899C1691.2 948.899 1680.2 968.099 1671.8 974.299C1671.8 974.299 1684 958.699 1684 947.199",
    stroke: "#B88261",
    strokeWidth: 1.5314,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.3 974.5C1650.3 974.5 1653.7 980.3 1658.5 982.9C1663.2 985.5 1667.1 997.3 1667.2 1001.5C1667.2 1001.5 1662.9 1000.7 1656.8 995.6C1650.7 990.5 1650.6 986 1650.3 974.5Z",
    fill: "#9AC1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.3 974.5C1650.3 974.5 1651.2 978.2 1655.2 983.3C1659.2 988.4 1664.7 996.3 1667.1 1001.5",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651 985.3L1659.6 989.2L1658.5 983",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.2 989.598L1662.3 993.198L1661.8 986.398",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656.09 995L1665.09 997.7",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670.1 989.601C1670.1 989.601 1674.8 983.201 1680.7 977.601C1686.6 972.001 1692.3 967.801 1692.3 967.801C1692.3 967.801 1690.8 973.201 1690.7 976.701C1690.7 980.201 1687.4 985.401 1681.8 986.301C1676.2 987.201 1672.6 987.301 1670.1 989.601Z",
    fill: "#9AC1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.4 967.801C1692.4 967.801 1686.3 977.001 1682.1 980.601C1677.9 984.201 1673.4 986.401 1670.2 989.601",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690 980.002L1679.9 982.302L1680.7 977.602",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.8 973.902L1684.2 978.502L1690.9 975.602",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671 1024.8C1671 1024.8 1671.6 1018.9 1676.6 1012.9C1681.6 1006.9 1688.4 1001.4 1694.9 993.302C1701.4 985.202 1701.7 983.902 1701.7 983.902C1701.7 983.902 1703.1 1002.2 1697.8 1008.6C1692.4 1015 1685.8 1017 1681.3 1018.7C1676.9 1020.5 1673 1021.6 1671 1024.8Z",
    fill: "#9AC1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.8 984.004C1701.8 984.004 1698 996.204 1690.6 1004.3C1683.2 1012.4 1671.2 1019.8 1671.1 1024.9",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1682.2 1006.8L1680.2 1013.7C1680.2 1013.7 1687.1 1013.7 1697.2 1009.3",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.2 1001.8L1685.7 1008.9C1685.7 1008.9 1694.3 1004.7 1701.3 999.102",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645 1025.6C1645 1025.6 1648.9 1028.2 1658 1030.3C1667.1 1032.4 1670.7 1035.8 1675 1043.1C1675 1043.1 1670.8 1040.5 1664.9 1041C1659 1041.7 1653.6 1037.6 1645 1025.6Z",
    fill: "#9AC1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645 1025.6C1645 1025.6 1648.4 1028.7 1654 1031.6C1659.6 1034.5 1672.5 1039.3 1675 1043",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651 1033.2L1658 1033.5L1654.5 1029.4",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656.2 1038.2L1664 1036.2L1660.8 1031",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665 1041L1668.2 1038.2L1667.1 1033.8",
    stroke: "#B88261",
    strokeWidth: 0.7657,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607.3 971.4C1610.3 969.4 1615.2 968 1618.5 968.5C1621.8 969 1625.9 971.2 1628.8 971.9C1631.7 972.5 1640.6 971.6 1646.6 975.3C1652.7 979.1 1654 981.7 1650.1 988.8C1646.2 995.9 1637.6 1004.7 1628.1 1009C1618.6 1013.3 1606.7 1015.5 1599.1 1012.5C1591.4 1009.5 1589.3 1004.2 1592.1 999.3C1595 994.3 1596.9 991.5 1597.9 987.5C1599.1 983.6 1600.6 975.7 1607.3 971.4Z",
    fill: "#F3C6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1639.1 978.801C1639.1 978.801 1638.9 983.001 1635.3 987.101",
    stroke: "#B88261",
    strokeWidth: 1.0278,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.5 988.801C1633.5 988.801 1632.6 989.801 1631.7 990.401",
    stroke: "#B88261",
    strokeWidth: 1.0278,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1606.6 1001.3C1606.6 1001.3 1600.4 1001.1 1598.1 998.801",
    stroke: "#B88261",
    strokeWidth: 1.0278,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.1 979.101C1606.8 978.901 1607.1 980.801 1608.2 982.001C1609.3 983.201 1610.1 987.001 1606.4 985.401C1602.7 983.801 1602.4 979.401 1605.1 979.101Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612.9 983.401C1614.4 983.001 1616.2 983.601 1616.4 984.801C1616.6 986.001 1616.2 987.601 1614.2 987.001C1612.2 986.501 1612 983.601 1612.9 983.401Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1607.9 988.699C1609.9 987.299 1612.2 988.499 1613.7 989.299C1615.2 990.099 1615 991.099 1613.5 992.499C1612.1 993.899 1610.8 994.599 1608.5 993.599C1606.2 992.599 1606.5 989.599 1607.9 988.699Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.6 1004.8C1635.6 1004.8 1641.4 1016.4 1644.6 1030.4C1647.8 1044.4 1644.8 1054.2 1644.4 1057C1643.9 1059.7 1643.1 1061.6 1638.5 1061C1633.9 1060.4 1632.2 1057.3 1632 1055.2C1631.8 1053 1633.1 1044.3 1633.3 1039C1633.5 1033.7 1633.3 1025.8 1631.5 1020.2C1629.7 1014.6 1626.7 1009.9 1626.7 1009.9C1626.7 1009.9 1632.8 1006.8 1635.6 1004.8Z",
    fill: "#F3C6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1635.6 1004.8L1637.1 1008.2C1637.1 1008.2 1634.8 1010.4 1632.1 1011.3C1629.5 1012.2 1627.9 1012.2 1627.9 1012.2L1626.5 1009.8C1626.6 1009.7 1631.9 1007.6 1635.6 1004.8Z",
    fill: "#F6B09E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783.2 950.504C1783.2 950.504 1783.8 952.404 1785.4 955.404C1786.9 958.404 1792.9 960.004 1794.4 963.904C1795.9 967.804 1792.3 971.504 1792.3 971.504C1792.3 971.504 1794.5 969.604 1796.1 969.004C1797.7 968.404 1799.9 973.804 1804.7 981.004C1809.5 988.204 1811.3 994.804 1811.2 997.904C1811 1001 1808.6 1003 1805.1 1005.2C1805.1 1005.2 1805.9 1005.6 1808.7 1005.1C1811.5 1004.6 1813.7 1004.8 1817.6 1013.3C1821.4 1021.7 1825.3 1032.7 1819.8 1038.7C1814.4 1044.7 1811.6 1048.9 1802.9 1050.8C1794.2 1052.7 1786.8 1050.6 1783.1 1046.7C1779.4 1042.9 1776.2 1037.4 1775.2 1032.3C1774.2 1027.3 1774.3 1019.3 1774.5 1018.5C1774.7 1017.7 1774.9 1017.5 1776.3 1017.7C1777.7 1017.9 1778.7 1018.3 1779.1 1017.9C1779.5 1017.5 1778.1 1015.7 1776.4 1014.6C1774.6 1013.6 1773.1 1012.3 1773.3 1010.7C1773.5 1009.1 1773.4 987.204 1773.7 983.704C1774 980.204 1774.4 974.704 1775 973.104C1775.5 971.604 1775.8 971.104 1777 971.404C1778.2 971.704 1779.4 972.304 1780 972.204C1780.6 972.104 1778.6 971.204 1777.6 969.704C1776.6 968.304 1773.6 964.704 1776 961.504C1778.4 958.204 1781.2 956.104 1781.8 954.604C1782.2 953.204 1782.6 951.304 1783.2 950.504Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800 973.402C1800 973.402 1794.6 980.802 1787.8 988.102L1786.8 989.102C1786.8 989.102 1776.9 984.102 1773.7 982.002C1773.7 982.002 1773.4 987.902 1773.3 994.202C1773.3 994.202 1773.2 1003.2 1773.2 1004.9C1773.2 1004.9 1787.7 1013.7 1791 1015.6C1791 1015.6 1797.9 1010.3 1805.1 1005.1C1812.3 999.802 1811.3 1000.1 1811 995.302C1810.6 990.402 1808.6 987.102 1806.1 983.102C1803.5 979.202 1800 973.402 1800 973.402Z",
    fill: "#E7B283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810.7 1065.5C1812.5 1064.8 1812.6 1064.5 1810.7 1062.9C1808.8 1061.4 1806.9 1059.4 1804.1 1054.8C1801.3 1050.2 1793.9 1022.7 1791 1008.9C1788 995.102 1783.2 950.402 1783.2 950.402C1783.2 950.402 1784 968.202 1785.4 981.402C1786.8 994.602 1788.5 1012.9 1794.6 1033.2C1800.7 1053.5 1801.9 1055.3 1803.5 1057.8C1805.1 1060.4 1807.5 1064.2 1808.4 1064.7C1809.4 1065.4 1810 1065.8 1810.7 1065.5Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815.6 1009.5C1815.6 1009.5 1814.1 1014 1812.2 1016.8",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.39 1024.1C1805.39 1024.1 1798.99 1031.5 1797.49 1034.6",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1814.49 1026.6C1814.49 1026.6 1813.09 1030.8 1810.19 1034.9C1807.29 1039.1 1801.79 1046.6 1801.89 1049.1",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.59 1043.2C1797.59 1043.2 1791.79 1040.1 1786.59 1037C1781.39 1034 1774.49 1028.6 1774.49 1028.6",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.9 1037.7C1795.9 1037.7 1787.7 1031.5 1785.7 1029.9",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.7 1025L1774.3 1021.1",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1799.19 995.199C1799.19 995.199 1793.19 1000.7 1789.99 1003.3",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1794.7 989.301L1788.7 994.801",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.3 998.099L1781.4 995.199",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.7 1000.8C1787.7 1000.8 1777.6 997.499 1773.3 994.199",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1809.2 988.602C1809.2 988.602 1807 991.602 1803.9 994.302",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810.8 994.199C1810.8 994.199 1807.5 997.599 1803.4 999.899",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1802.3 1011.9C1802.3 1011.9 1796.1 1017.9 1793.7 1020.2",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.2 1010.1C1773.2 1010.1 1779 1014.6 1783.7 1017.5",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.8 959.199C1777.8 959.199 1779.2 961.899 1780.4 963.499",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.3 958.801C1789.3 958.801 1789 959.201 1787.9 961.001",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.1 960.102C1791.1 960.102 1790.5 961.402 1788.7 963.102",
    stroke: "#B88261",
    strokeWidth: 0.6323,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.3 935.203C1701.3 935.203 1701.5 938.703 1704 941.603C1706.6 944.603 1712.5 948.803 1717.5 957.303C1722.5 965.803 1723.1 971.803 1723.4 974.703C1723.8 977.603 1725.2 979.003 1726.3 983.703C1726.3 983.703 1725 981.103 1719.8 977.603C1714.6 974.203 1708.8 968.703 1705.7 962.303C1702.7 955.903 1703.5 952.003 1702.4 949.203C1701.3 946.403 1700.4 945.303 1700.4 943.003C1700.6 940.803 1701.1 939.603 1701.3 935.203Z",
    fill: "#9AC1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725.7 983.601C1725.7 983.601 1724.4 981.301 1718.5 979.601C1712.6 977.901 1708.3 975.801 1705.1 972.601C1702.1 969.301 1700.9 964.001 1691.6 959.301C1691.6 959.301 1694.3 960.701 1697 968.801C1699.7 976.901 1703.6 981.901 1706.8 984.101C1709.8 986.301 1712.8 988.101 1716.3 984.101C1719.9 980.001 1725.7 983.601 1725.7 983.601Z",
    fill: "#C0DEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.2 971.602C1701.2 971.602 1704.6 977.202 1708.6 978.202C1712.7 979.202 1720.9 979.502 1726.4 983.902",
    stroke: "#B88261",
    strokeWidth: 0.915,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1733.1 994.604C1733.1 994.604 1731 992.204 1728.9 993.004C1726.8 993.804 1724.6 996.404 1716.6 992.804C1708.6 989.104 1712.3 990.404 1707.8 988.204C1703.3 986.004 1701.7 984.004 1701.7 984.004C1701.7 984.004 1706.2 990.504 1707.8 993.404C1709.4 996.304 1713.6 1002 1718.7 1001.9C1723.8 1001.8 1725.8 1000.1 1726.8 998.304C1727.7 996.504 1729.9 992.804 1733.1 994.604Z",
    fill: "#9AC1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.8 992.004C1710.8 992.004 1715.5 997.004 1719.9 996.704C1724.4 996.504 1729.5 990.904 1733 994.604",
    stroke: "#B88261",
    strokeWidth: 0.915,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.5 1012.4C1744.5 1012.4 1741.2 1006.9 1733.9 1007.6C1726.6 1008.3 1724.3 1012.4 1719.3 1010C1714.3 1007.5 1711.6 1004.6 1711.6 1004.6C1711.6 1004.6 1717 1016.1 1723.4 1020C1729.7 1024 1735.3 1015.4 1737.7 1013.5C1740 1011.6 1742.6 1010.8 1744.5 1012.4Z",
    fill: "#C0DEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1721.9 1012.8C1721.9 1012.8 1723.7 1015.5 1729.7 1012.8C1735.7 1010.1 1739.9 1008.2 1744.5 1012.4",
    stroke: "#B88261",
    strokeWidth: 0.915,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.1 956.504C1743.1 956.504 1743.8 958.204 1743.6 960.704C1743.4 963.304 1743.7 965.404 1745.2 970.904C1746.7 976.404 1747.2 979.904 1742.2 985.104C1737.3 990.304 1732.7 991.304 1732.1 993.404C1732.1 993.404 1731.1 991.004 1733.1 987.204C1734.9 983.404 1739.7 977.704 1740.2 974.104C1740.8 970.504 1740.5 966.604 1741 964.404C1741.6 962.404 1743.1 961.804 1743.1 956.504Z",
    fill: "#9AC1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1725.7 933.902C1725.7 933.902 1727.9 936.102 1728 940.102C1728 944.002 1729.4 948.702 1733.2 953.702C1737 958.702 1738.6 965.002 1737.3 969.902C1736 974.802 1728.8 977.102 1728 977.702C1727.2 978.302 1724.6 981.202 1726.6 985.202C1726.6 985.202 1724.5 981.002 1726.5 977.702C1728.5 974.402 1731.4 972.702 1729 965.102C1726.6 957.502 1725.8 953.502 1725.7 949.002C1725.6 944.502 1729.4 938.002 1725.7 933.902Z",
    fill: "#C0DEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.5 954.301C1728.5 954.301 1732.3 959.401 1732 965.501C1731.8 971.601 1730.5 972.801 1728.5 975.201C1726.5 977.601 1724.3 980.401 1727.2 985.101",
    stroke: "#B88261",
    strokeWidth: 0.915,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.6 957.801C1710.6 957.801 1714.6 968.001 1719.3 973.601C1724 979.101 1726.3 983.801 1726.3 983.801",
    stroke: "#B88261",
    strokeWidth: 0.915,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1741.8 977.602C1741.8 977.602 1741.2 981.402 1738.5 984.102C1735.8 986.702 1732.7 990.502 1732.3 993.502",
    stroke: "#B88261",
    strokeWidth: 0.915,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.4 969.902C1762.4 969.902 1758.5 971.502 1757.1 974.602C1755.7 977.702 1757.1 981.902 1752.2 986.502C1747.3 991.202 1742.6 993.202 1741.7 997.102C1740.8 1000.9 1741.9 1008 1743.5 1011.2C1743.5 1011.2 1743 1006.3 1750.5 1005.4C1758 1004.4 1765.9 999.502 1764.6 992.002C1763.3 984.502 1759.4 975.602 1762.4 969.902Z",
    fill: "#C0DEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.9 986.203C1757.9 986.203 1758.5 990.603 1753.1 994.403C1747.7 998.203 1741.7 1004.5 1743.5 1011.2",
    stroke: "#B88261",
    strokeWidth: 0.915,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.9 1004.5C1775.9 1004.5 1771.3 1010.6 1767 1011.9C1762.7 1013.3 1756.9 1018.5 1755.2 1022.3C1753.5 1026.1 1754.4 1031.2 1754.4 1031.2C1754.4 1031.2 1755.2 1029.8 1758.7 1028.6C1762.2 1027.2 1764.5 1021.8 1765.7 1018C1766.8 1014 1773.8 1007.4 1775.9 1004.5Z",
    fill: "#9AC1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.4 1019.4C1761.4 1019.4 1759.5 1022.4 1758 1023.9C1756.5 1025.4 1754.3 1028.6 1754.5 1031.3",
    stroke: "#B88261",
    strokeWidth: 0.915,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.7 1019.4C1706.7 1019.4 1708.9 1020.9 1711.6 1021C1714.2 1021.2 1718.2 1021.7 1723.6 1025.3C1729 1028.9 1736.2 1030.7 1739.8 1030.6C1743.5 1030.4 1752.6 1028.1 1754.1 1034.1C1754.1 1034.1 1752.1 1031.2 1747.6 1033.1C1743.1 1035 1737.2 1041.5 1730.3 1040.1C1723.4 1038.7 1717.6 1030.9 1713.3 1027.9C1709.2 1024.8 1710.6 1021.8 1706.7 1019.4Z",
    fill: "#9AC1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.1 1027.9C1720.1 1027.9 1724.9 1031.7 1730.4 1033.1C1735.9 1034.5 1738.8 1034.1 1741.7 1033.1C1744.7 1032.1 1750.3 1029.4 1754.2 1034.1",
    stroke: "#B88261",
    strokeWidth: 0.915,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.8 1062.4C1765.4 1061.9 1765.3 1061.8 1762.8 1057.2C1760.3 1052.7 1759.4 1045.8 1757.9 1041.1C1756.4 1036.4 1757.1 1032 1748.5 1017.9C1739.9 1003.8 1725.7 982.102 1725.7 982.102V983.702C1725.7 983.702 1744 1011.7 1750.6 1024.8C1757.2 1037.9 1757.6 1049 1758 1053.3C1758.2 1057.3 1758.2 1063.2 1762.8 1062.4Z",
    fill: "#B88261"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.3 1049.7C301.9 1040.9 299.8 1032.3 295.9 1024.4C293 1018.6 289.3 1013.2 284.7 1008.5C277.9 1001.4 268.6 995.1 256.5 993.4C230.5 989.9 224.7 1012.3 223.6 1018.4C224.5 1011.4 225.6 982 188.2 968.6C145.5 953.4 114.8 986.1 115.6 1007.6C115.6 1007.6 103.9 999.6 90.7 1011.2C77.5 1022.8 79.9 1045 79.9 1045C79.9 1045 73.1 1024.5 45.9 1027.3C18.7 1030.1 20.2 1059.8 20.2 1059.8C20.2 1059.8 17.5 1049.8 4 1048.7C-9.4 1047.6 -10 1080.9 -10 1080.9H303.9L302.3 1049.7Z",
    fill: "#E3A194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.898 958.699V964.099",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.297 961.398H149.697",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 1080.9C41 1080.9 45.9 1037 56.4 1028.9C66.9 1020.7 69.5 1031.2 68.7 1035.6C67.9 1040 62.9 1041.8 64.9 1031.2C66.9 1020.6 76.3 1008.1 88.7 1004.9C101.1 1001.7 103.9 1011.3 101.5 1013.9C99.1 1016.5 90.8 1012.3 110 998.501C129.2 984.701 152.6 985.501 161.6 998.501C170.6 1011.5 160.1 1027.4 155 1025.5C150 1023.7 157.6 1004.9 175.8 1008.7C194 1012.5 190.7 1028.9 187.2 1033.9C183.7 1038.9 180.2 1028.6 196.6 1023.3C212.9 1017.9 220 1025.2 222.6 1033.9C225.2 1042.6 219.7 1045 215.6 1044.3C211.5 1043.7 218.2 1026.5 236.6 1027.6C254.9 1028.7 260.2 1080 260.2 1080",
    stroke: "#B88261",
    strokeWidth: 1.2509,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.897 970.602C160.897 970.602 137.297 988.702 132.197 1017C127.097 1045.3 138.397 1070.2 138.397 1070.2C138.397 1070.2 160.597 1048.4 164.697 1021C168.897 993.702 160.897 970.602 160.897 970.602Z",
    fill: "#C0DEC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.697 978.902L147.997 983.802L143.297 990.402L156.997 985.202L165.397 994.502L164.397 985.602L158.697 978.902Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.094 1003.8L154.594 994.002L165.694 1010.4C165.694 1010.4 166.094 1000.3 165.394 994.502L156.894 985.102L143.094 990.302C143.294 990.402 138.494 997.102 136.094 1003.8Z",
    fill: "#E7B283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.098 1006.4L142.898 1015.2L147.698 1028.4L156.898 1016.5L151.098 1006.4Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.598 1021.1L144.798 1040.5L162.998 1028.7C162.998 1028.7 161.998 1034.2 159.398 1039.3L142.598 1049.9L130.898 1034C130.898 1033.9 131.098 1024.2 131.598 1021.1Z",
    fill: "#E7B283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9 1059.7L153.5 1050.5L159.5 1039.2L142.7 1049.8L131 1033.9C131 1033.9 131.3 1041.1 131.7 1044.3L140.9 1059.7Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.604 984.602C202.604 984.602 201.004 999.602 198.504 1015.7C196.004 1031.8 193.304 1040.7 186.304 1045.5C179.304 1050.3 175.704 1050.3 171.704 1057.1C171.704 1057.1 170.304 1041.7 182.704 1023.2C195.104 1004.6 202.604 984.602 202.604 984.602Z",
    fill: "#9AC1A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.603 984.602C202.603 984.602 196.903 1007.6 189.803 1023.7C182.703 1039.8 173.903 1050.6 171.703 1057.1",
    stroke: "#B88261",
    strokeWidth: 1.0659,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.603 1004.5L192.703 1016.5L200.003 1005.6",
    stroke: "#B88261",
    strokeWidth: 1.0659,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.905 1018.2L185.805 1031.8L197.305 1022.9",
    stroke: "#B88261",
    strokeWidth: 1.0659,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.106 1029.1L178.906 1043.9L192.506 1038.2",
    stroke: "#B88261",
    strokeWidth: 1.0659,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.898 920.199V944.999",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.898 932.598H158.898",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.398 927.199L170.298 937.999",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.298 927.199L161.398 937.999",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.695 985.699V1005.9",
    stroke: "#B88261",
    strokeWidth: 0.8206,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.298 995.801H241.898",
    stroke: "#B88261",
    strokeWidth: 0.8206,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 991.398L251.3 1000.2",
    stroke: "#B88261",
    strokeWidth: 0.8206,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.3 991.398L244 1000.2",
    stroke: "#B88261",
    strokeWidth: 0.8206,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.602 958.699V964.099",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.898 961.398H107.298",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.406 911V916.4",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.703 913.801H238.103",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9062 993.898V999.298",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2031 996.598H55.6031",
    stroke: "#B88261",
    strokeWidth: 1.006,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.103 988.101C112.103 990.901 114.303 994.101 115.803 999.501C117.203 1004.9 116.803 1005 118.203 1009.7C119.603 1014.4 122.603 1020.8 120.703 1027.2L70.7031 998.001C70.7031 998.001 71.4031 994.201 75.9031 992.201C80.4031 990.301 85.9031 989.601 88.3031 988.801C90.7031 987.901 94.7031 985.401 97.5031 985.001C102.003 984.201 105.603 986.201 108.103 988.101Z",
    fill: "#E29376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.702 1023.8C104.202 1025.9 114.102 1029.6 117.302 1029.4C120.502 1029.2 122.202 1026.7 119.502 1021.9C116.802 1017 103.402 1005.4 90.5023 1000.1C77.6023 994.8 72.7023 996.5 71.5023 997.1C70.3023 997.7 70.1023 1000.8 74.9023 1005.4C79.7023 1010 87.8023 1015.7 90.3023 1017.6C92.6023 1019.3 98.5023 1022.4 100.702 1023.8Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.803 1008.8C105.803 1008.8 102.703 1012.3 96.7031 1013.2",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1047 1002.8C96.1047 1002.8 93.0047 1006.9 94.7047 1012.1",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9062 997.801C83.9062 997.801 86.1062 1007.7 92.1062 1010.6",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4062 997C71.4062 997 74.0062 1004.3 91.2062 1010",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1094 1011.4C82.1094 1011.4 86.6094 1012.7 92.5094 1010.8",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.303 1017.8C116.303 1017.8 108.903 1019.2 102.703 1016.7",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.509 1027.7C120.509 1027.7 111.709 1028 103.109 1017.5",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.603 1025.6C104.603 1025.6 101.803 1023.3 101.203 1018.5",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7038 1043.8C80.0038 1035.8 80.9038 1028.2 82.6038 1022.7C84.3038 1017.2 89.6038 1010.7 90.8038 1009.8C91.9038 1008.9 95.2038 1010.3 98.3038 1012.6C101.404 1014.9 104.104 1017.4 103.704 1018.4C103.304 1019.4 100.404 1024.2 99.3038 1027.8C98.3038 1031.4 97.8038 1033.7 99.1038 1041.2C100.404 1048.6 103.404 1053 100.304 1056.1C97.2038 1059.1 91.7038 1058.9 86.6038 1057.4C81.5038 1055.9 79.7038 1054.3 79.6038 1051.4C79.3038 1048.2 79.7038 1045.4 79.7038 1043.8Z",
    fill: "#E7B283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.099 1001.8C115.499 1001.5 115.599 1002.5 115.599 1003.6C115.499 1004.6 114.999 1005.5 114.099 1004.2C113.299 1002.9 113.199 1002.1 114.099 1001.8Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.401 1006.4C114.801 1006 115.901 1008.2 116.301 1009.4C116.701 1010.6 116.901 1012.4 115.301 1011.2C113.601 1010.1 114.201 1009.1 113.501 1008.2C112.701 1007.3 112.301 1006.7 113.401 1006.4Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9029 987.1C100.203 988 99.5029 988.6 98.2029 988.6C96.9029 988.6 95.1029 987.5 96.8029 987.1C98.4029 986.7 98.1029 986.6 98.9029 987.1Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2028 989.399C95.0028 989.399 95.0028 989.999 95.5028 990.399C95.9028 990.799 95.2028 991.399 94.0028 991.199C92.7028 990.999 92.3028 990.999 91.6028 990.999C90.9028 990.999 90.5028 989.299 93.2028 989.399Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1047 992.3C98.5047 991.5 99.9047 992.4 100.305 992.7C100.605 993.1 100.305 994.2 99.2047 993.7C98.1047 993.3 97.7047 993.1 98.1047 992.3Z",
    fill: "#F9D4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2031 997.302C94.2031 997.302 93.1031 996.602 90.2031 995.602",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3016 994.8C87.3016 994.8 83.9016 993.8 82.1016 993.5",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.803 1028.5C119.803 1028.5 121.603 1028.2 120.403 1023.6C119.203 1019 107.403 1008.2 94.2031 1001.7C81.0031 995.3 71.6031 995.3 70.7031 997.9",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.203 894.7C202.503 894 201.703 896.5 201.103 899.9C200.503 903.3 200.403 922.3 200.503 925.6C200.703 928.9 202.903 934.2 205.703 938C208.503 941.8 210.303 943.2 212.403 943.1C214.603 943 214.303 938.6 212.503 933.2C210.703 927.8 209.403 920.6 207.303 914C205.203 907.4 205.203 901.8 205.003 899.9C204.903 897.9 204.003 895.5 203.203 894.7Z",
    fill: "#F6B09E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.406 921.199C203.406 921.199 204.406 925.299 205.606 929.099C206.806 932.899 208.806 934.499 210.106 937.599C211.406 940.599 212.506 943.099 212.506 943.099",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.9 895.099C206.7 894.699 207.8 899.199 210.7 904.099C213.7 909.099 218.6 917.399 220.1 920.899C221.6 924.399 222.4 925.899 222.2 931.399C222 936.899 217.6 946.399 215.2 943.899C212.8 941.399 211.7 932.999 209.4 928.899C207.2 924.699 204.7 913.799 204.1 909.199C203.5 904.599 203.5 902.899 203.5 900.499C203.8 898.199 203.7 895.399 204.9 895.099Z",
    fill: "#F3C6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.305 909.398C209.305 909.398 213.705 920.998 215.005 929.298C216.405 937.598 215.805 944.298 215.805 944.298",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.906 924.199C216.906 924.199 218.306 929.899 218.106 934.399C217.906 938.999 217.106 944.099 217.106 944.099",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.799 986.301C189.199 984.101 187.699 980.501 189.399 977.501C190.999 974.501 195.299 981.301 198.599 983.001C201.899 984.801 212.399 988.701 212.399 988.701C212.399 988.701 208.099 989.601 204.599 989.401C201.099 989.201 199.299 988.301 197.199 987.701C194.999 987.201 191.599 987.401 190.799 986.301Z",
    fill: "#F6B09E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.701 960.202C187.901 959.802 186.401 960.402 185.801 961.602C185.201 962.802 185.601 964.102 186.301 967.402C187.001 970.802 187.301 972.502 187.501 974.502C187.701 976.402 189.601 977.502 190.501 978.702C191.501 980.002 193.101 982.102 193.901 983.002C194.701 983.902 196.501 982.002 195.901 976.902C195.301 971.902 195.601 970.502 194.701 967.902C193.701 965.402 192.501 960.902 189.701 960.202Z",
    fill: "#F6B09E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.198 978.501C211.198 978.501 205.798 974.401 202.698 970.201C199.698 966.001 196.098 962.001 193.698 959.701C191.398 957.401 188.698 956.001 187.998 957.101C187.298 958.201 187.798 960.501 188.798 963.301C189.798 966.101 189.898 965.501 189.398 967.301C188.798 969.101 189.598 969.601 190.598 971.501C191.598 973.301 191.398 974.501 191.598 977.501C191.798 980.501 192.998 983.201 195.798 985.101C198.498 986.901 203.898 988.601 206.598 989.001C209.298 989.501 212.998 988.901 214.598 987.601C216.198 986.201 215.298 983.801 213.798 981.901C212.498 979.901 211.198 978.501 211.198 978.501Z",
    fill: "#F3C6B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.703 973.801C200.403 974.201 203.503 976.401 206.803 978.501C210.103 980.601 214.203 984.101 214.203 984.101",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.597 987.401C213.597 987.401 209.797 986.901 206.597 985.301C203.297 983.801 199.797 980.801 199.797 980.801",
    stroke: "#B88261",
    strokeWidth: 0.7974,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.001 931.101C225.601 931.101 223.001 934.501 222.101 939.501C221.201 944.501 220.401 946.201 220.401 950.001C220.401 953.801 221.601 960.401 223.301 966.301C225.001 972.201 225.401 973.301 227.901 978.801C230.501 984.301 234.301 993.701 233.101 1002.6C231.901 1011.5 231.001 1008.2 228.801 1019.1C226.601 1029.9 224.001 1034.1 223.001 1039.4C222.001 1044.7 220.501 1047.6 220.501 1051.4C220.401 1055.2 221.901 1058.7 218.701 1058.4C215.601 1058 215.701 1052.5 215.601 1049.8C215.501 1047.2 218.001 1044.8 218.601 1042.4C219.201 1040.1 224.201 1023.3 224.801 1016.2C225.401 1009.2 227.501 1004.1 223.901 997.201C220.301 990.301 216.501 988.801 215.401 989.401C214.401 990.001 209.401 991.201 207.701 991.601C206.001 992.001 205.201 991.901 205.101 991.001C204.901 990.101 208.101 987.301 210.901 987.001C210.901 987.001 204.501 983.001 204.801 981.201C205.101 979.301 214.101 984.101 214.101 984.101C214.101 984.101 211.101 980.901 211.001 978.501C211.001 976.101 210.501 975.501 211.601 975.101C212.601 974.801 212.001 977.801 213.101 979.101C214.201 980.401 215.001 981.601 218.101 984.701C221.101 987.801 228.001 993.101 228.701 1004.1C228.701 1004.1 231.801 997.401 228.501 989.601C225.101 981.801 220.501 970.201 218.901 967.001C217.301 963.801 216.301 954.801 215.501 952.001C214.801 949.101 212.501 946.701 210.701 945.401C208.901 944.001 205.801 940.601 204.601 938.501C203.301 936.401 202.901 933.601 203.701 933.301C204.501 932.901 206.301 934.301 208.101 935.901C209.901 937.501 210.801 939.701 210.801 939.701C210.801 939.701 210.201 937.201 210.301 933.201C210.501 929.201 211.801 927.601 211.601 926.601C211.401 925.601 213.201 924.901 214.301 926.801C215.401 928.701 216.101 931.001 216.901 933.001C217.801 935.001 217.501 938.001 217.501 938.001C217.501 938.001 218.501 937.201 219.301 934.601C220.401 932.201 221.801 931.101 224.001 931.101Z",
    fill: "#9AC1A9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8964_33909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage12);
export default __webpack_public_path__ + "static/media/image12.05f729f884f03369ee5f0923e3b77028.svg";
export { ForwardRef as ReactComponent };